import { FormFieldAutocomplete } from '@/global/components/Form'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

/** Segmentos mais comuns entre clientes do Ponto Ágil. Não precisa bater 1:1
 * com a tabela: o usuário pode digitar qualquer outro e o backend resolve por
 * nome (cria se não existir) no cadastro da avaliação. */
const PRINCIPAIS_SEGMENTOS = [
    'Indústria',
    'Construtora',
    'Restaurante',
    'Supermercado',
    'Escritório de contabilidade',
    'Clínica médica',
    'Escola',
    'Transportadora',
    'Hotel',
    'Loja de roupas',
    'Farmácia',
    'Oficinas',
]

interface IProps {
    required?: boolean
}

export function SelectSegmento({ required }: IProps) {
    const { setValue } = useFormContext()
    const [busca, setBusca] = useState('')

    const digitado = busca.trim()
    const jaExiste = PRINCIPAIS_SEGMENTOS.some(
        segmento => segmento.toLowerCase() === digitado.toLowerCase(),
    )

    return (
        <FormFieldAutocomplete
            name="Segmento.nome"
            rules={required ? { required: 'Obrigatório' } : undefined}
            label="Segmento"
            placeholder="Digite ou escolha o segmento"
            required={required}
            options={PRINCIPAIS_SEGMENTOS}
            onInputChange={setBusca}
            searchPlaceholder="Buscar ou digitar para criar um segmento"
            creatableOption={
                digitado && !jaExiste
                    ? {
                          label: `Outro: ${digitado}`,
                          onClick: () =>
                              setValue('Segmento.nome', digitado, {
                                  shouldValidate: true,
                                  shouldDirty: true,
                              }),
                      }
                    : undefined
            }
        />
    )
}
